<script setup>
defineProps({
  featuredPosts: {
    type: Object,
    required: true
  }
})

const PLACEHOLDER = 'https://via.placeholder.com/64x64'
const { altFallback } = usePageAltFallback()

const postThumbSrc = (post) =>
  post?.attributes?.image?.data?.attributes?.url
  || post?.attributes?.boltImage
  || PLACEHOLDER

const postThumbAlt = (post) =>
  resolveMediaAlt(
    post?.attributes?.image?.data?.attributes || post?.attributes?.image,
    post?.attributes?.title,
    altFallback.value
  )
</script>

<template>
  <section class="featured-posts">
    <h3 class="featured-posts-title">Featured Posts</h3>
    <div
      class="featured-post-row row"
      v-for="post in featuredPosts"
      :key="post.id || post.attributes?.slug"
    >
      <a :href="`/blog/${post.attributes.slug}`" class="featured-post">
        <div class="featured-post-inner">
          <div class="col-3 post-image-container">
            <img
              :src="postThumbSrc(post)"
              :alt="postThumbAlt(post)"
              loading="lazy"
              decoding="async"
            >
          </div>
          <div class="col-9 post-title" v-html="post.attributes.title"></div>
        </div>
      </a>
    </div>
  </section>
</template>

<style lang="scss">
.featured-posts{
  background: $color-lightest-gray;
  padding: 20px 20px 40px;
  border-radius: 24px;
  margin-bottom: 20px;
  .featured-posts-title{
    margin-bottom: 20px;
  }
  .featured-post-row{
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0;
      .featured-post{
        .featured-post-inner{
          padding-bottom: 0;
          border-bottom: 0;
        }
      }
    }
    .featured-post{
      text-decoration: none;
      .featured-post-inner{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        padding-bottom: 12px;
        border-bottom: solid 1px $color-accent;
      }
      .post-image-container{
        height: 64px;
        width: 64px;
        border-radius: 8px;
        margin-right: 10px;
        overflow: hidden;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
      .post-title{
        font-weight: 600;
        color: $color-labels;
      }
    }
  }  
}
</style>
